import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

import { TooltipContext } from '@providers/TooltipProvider';
import messages from './messages';

function MaxProductQuantity({
  isTooltipClosed,
  quantity,
  closeMaxProductQuantityTooltip,
  intl: { formatMessage },
}) {
  const maxQuantityLabelRef = useRef();
  const { setTooltip } = useContext(TooltipContext);

  useEffect(() => {
    if (!isTooltipClosed && quantity) {
      setTooltip({
        content: formatMessage(messages.tooltipMessage),
        target: maxQuantityLabelRef.current,
        open: true,
        onClose: closeMaxProductQuantityTooltip,
        styles: { maxWidth: '80%' },
      });
    }
    return () => {
      setTooltip({ open: false });
    };
  }, [
    quantity,
    isTooltipClosed,
    setTooltip,
    maxQuantityLabelRef,
    formatMessage,
    closeMaxProductQuantityTooltip,
  ]);

  return (
    <FormattedMessage
      {...messages.maxProductQuantity}
      values={{ maxProductQuantity: quantity }}
    >
      {msg => <label ref={maxQuantityLabelRef}>{msg}</label>}
    </FormattedMessage>
  );
}

MaxProductQuantity.propTypes = {
  isTooltipClosed: PropTypes.bool.isRequired,
  quantity: PropTypes.number,
  closeMaxProductQuantityTooltip: PropTypes.func.isRequired,
  intl: intlShape,
};

const Component = injectIntl(MaxProductQuantity);

function ProductQuantity({ quantity, ...props }) {
  return Boolean(quantity) && <Component quantity={quantity} {...props} />;
}

ProductQuantity.propTypes = {
  quantity: PropTypes.number,
};

export default ProductQuantity;
